<template>
  <div>
    <a-form-model
      ref="form"
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :rules="rules"
    >
      <a-form-model-item
        label="设备类型ID"
        prop="deviceTypeId"
      >
        <a-input v-model="form.deviceTypeId" />
      </a-form-model-item>
      <a-form-model-item
        label="设备类型"
        prop="name"
      >
        <a-input v-model="form.name" />
      </a-form-model-item>
      <a-form-model-item
        v-if="loadedDeviceTypeList"
        label="负载设备类型"
        prop="loadDeviceTypeId"
      >
        <a-select
          v-model="form.loadDeviceTypeId"
          show-search
          allow-clear
          placeholder="请选择负载设备类型"
        >
          <a-select-option
            v-for="loaded in loadedDeviceTypeList"
            :key="loaded.loadedDeviceTypeId"
          >
            {{
              loaded.name
            }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="英文名"
        prop="enName"
      >
        <a-input v-model="form.enName" />
      </a-form-model-item>
      <a-form-model-item
        label="模板ID"
        prop="templateId"
      >
        <a-input v-model="form.templateId" />
      </a-form-model-item>
      <!-- <a-form-model-item>
        <a-textarea
          v-model="form.remark"
          placeholder="服务商备注"
          :auto-size="{ minRows: 15, maxRows: 20 }"
          size="large"
        />
      </a-form-model-item> -->
      <a-form-item class="group-btn">
        <a-button
          type="primary"
          @click="createBrand"
        >
          确定
        </a-button>
        <a-button
          class="creator-btn"
          @click="cancel"
        >
          取消
        </a-button>
      </a-form-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  name: 'DeviceTypeCreator',
  components: {},
  data() {
    return {
      loadedDeviceTypeList: undefined,
      rules: {
        deviceTypeId: [{ required: true, message: '设备类型ID 不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '设备类型 不能为空', trigger: 'blur' }],
        enName: [{ required: true, message: '英文名 不能为空', trigger: 'blur' }],
        loadDeviceTypeId: [{ required: true, message: '负载设备类型 不能为空', trigger: 'change' }],
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        loadDeviceTypeId: undefined,
        name: undefined,
        // remark: null,
        enName: undefined,
        templateId: undefined,
      },
    }
  },
  mounted() {
    this.loadedDeviceType()
  },
  methods: {
    async loadedDeviceType() {
      const response = await this.$apiManager.deviceType.loadedDeviceType({ unpaged: true })
      this.loadedDeviceTypeList = response.data.elements
    },
    cancel() {
      this.$router.back()
    },
    createBrand() {
      this.$refs.form.validate((relsValid) => {
        if (relsValid) {
          this.$apiManager.deviceType.createDeviceTypes(this.form).then(() => {
            this.$message.success('创建成功')
            this.$router.back()
          })
        }
        else {
          this.$message.warn('基础信息存在未填写的数据')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.edit-btn {
  color: green;
}
.delete-btn {
  color: red;
}
.creator-btn {
  margin-left: 5%;
}
.service-provicer-operations {
  display: flex;
  .add-btn {
    margin: 10px 0px;
    margin-left: 3%;
  }
  .service-table {
    margin-top: 2%;
  }
}
.group-btn {
  margin-left: 16.7%;
}
</style>
